export default function content(category, token, allContent) {
  if (!allContent) {
    return `[${token}]`;
  }
  const content = allContent.find((c) => c.category.trim() === category)
    ?.clientContent.find((c) => c.token.trim() === token);
  if (content) {
    return content.text;
  }
  return `[${token}]`;
}
